import React, { useState } from 'react'; // Import useState
import { useNavigate } from 'react-router-dom';

const EmptyStateView = ({ onCreateNew }) => {
  const navigate = useNavigate();
  // CHANGE 5a: Add state to control animation trigger
  const [isAnimating, setIsAnimating] = useState(false);

  const handleCreateNew = () => {
    if (onCreateNew) {
      onCreateNew();
    } else {
      navigate('/guarantees/new');
    }
  };

  return (
    <div className="empty-state-container" style={{ 
      position: 'absolute', 
      top: 0, 
      left: 0, 
      width: '100%', 
      height: '100%',
      margin: 0,
      padding: 0
    }}>
      {/* Main Image */}
      <img
        src="images/mobi_promo.png"
        alt="Ihre erste Mobilitätsgarantie abschließen!"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          position: 'absolute',
          top: 0,
          left: 0
        }}
      />

      {/* Tow truck animation container */}
      <div className="tow-animation-container" style={{
        position: 'absolute',
        bottom: '5%',
        left: '48%',
        // CHANGE 4: Move group 30px left from center
        transform: 'translateX(calc(-50% - 30px))',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: 'auto', // Allow container to shrink if needed
        maxWidth: '240px' // Keep max width if desired
      }}>
        {/* Animation Scene */}
        {/* CHANGE 5b: Conditionally add 'animate' class */}
        <div className={`animation-scene ${isAnimating ? 'animate' : ''}`}>
          {/* Car */}
          <div className="car">
            {/* ... (car elements remain the same) ... */}
             <div className="car-body">
              <div className="car-top"></div>
              <div className="car-window"></div>
            </div>
            <div className="car-wheel front-wheel">
              <div className="wheel-center"></div>
            </div>
            <div className="car-wheel back-wheel">
              <div className="wheel-center"></div>
            </div>
            <div className="car-tow-anchor"></div>
          </div>

          {/* Tow Truck - Reversed */}
          <div className="tow-truck">
             {/* ... (truck elements remain the same) ... */}
            <div className="truck-cabin">
              <div className="truck-window"></div>
              <div className="truck-light"></div>
              <div className="roof-light-flasher"></div>
            </div>
            <div className="truck-body"></div>
            <div className="truck-bed"></div>
            <div className="tow-arm">
              <div className="tow-hook"></div>
            </div>
            <div className="truck-wheel front-wheel">
              <div className="wheel-center"></div>
            </div>
            <div className="truck-wheel back-wheel">
              <div className="wheel-center"></div>
            </div>
          </div>

          {/* Road */}
          <div className="road-surface"></div>
          <div className="road-line"></div>
        </div>

        {/* Action Button - Replaced with button-82 style */}
        <button
          className="button-82-pushable"
          onClick={handleCreateNew}
          onMouseEnter={() => setIsAnimating(true)}
          onMouseLeave={() => setIsAnimating(false)}
          style={{
            marginTop: '12px',
            position: 'relative',
            zIndex: 20
          }}
          role="button"
        >
          <span className="button-82-shadow"></span>
          <span className="button-82-edge"></span>
          <span className="button-82-front text">
            Mobilitätsgarantie abschließen
          </span>
        </button>

        <style jsx>{`
          /* Animation Scene */
          .animation-scene {
            /* CHANGE 2a: Make animation scene smaller */
            height: 50px;
            width: 100%; /* Keeps it responsive within its container */
            position: relative;
            display: flex;
            align-items: flex-end;
            overflow: hidden;
            background-color: transparent;
            border-radius: 5px;
          }

          /* Button-82 Styles */
          .button-82-pushable {
            position: relative;
            border: none;
            background: transparent;
            padding: 0;
            cursor: pointer;
            outline-offset: 4px;
            transition: filter 250ms;
            user-select: none;
            -webkit-user-select: none;
            touch-action: manipulation;
          }

          .button-82-shadow {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: 12px;
            background:rgb(95, 112, 21);
            will-change: transform;
            transform: translateY(2px);
            transition:
              transform
              600ms
              cubic-bezier(.3, .7, .4, 1);
          }

          .button-82-edge {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: 12px;
background: linear-gradient(
  to left,
  hsl(340deg 100% 16%) 0%,
  hsl(340deg 100% 32%) 8%,
  hsl(340deg 100% 32%) 92%,
  hsl(340deg 100% 16%) 100%
);
          }

          .button-82-front {
            display: block;
            position: relative;
            padding: 12px 27px;
            border-radius: 12px;
            font-size: 1.1rem;
            color: white;
            background: #a7ce00;
            will-change: transform;
            transform: translateY(-4px);
            transition:
              transform
              600ms
              cubic-bezier(.3, .7, .4, 1);
          }

          @media (min-width: 768px) {
            .button-82-front {
              font-size: 1.25rem;
              padding: 12px 42px;
            }
          }

          .button-82-pushable:hover {
            filter: brightness(110%);
            -webkit-filter: brightness(110%);
          }

          .button-82-pushable:hover .button-82-front {
            transform: translateY(-6px);
            transition:
              transform
              250ms
              cubic-bezier(.3, .7, .4, 1.5);
          }

          .button-82-pushable:active .button-82-front {
            transform: translateY(-2px);
            transition: transform 34ms;
          }

          .button-82-pushable:hover .button-82-shadow {
            transform: translateY(4px);
            transition:
              transform
              250ms
              cubic-bezier(.3, .7, .4, 1.5);
          }

          .button-82-pushable:active .button-82-shadow {
            transform: translateY(1px);
            transition: transform 34ms;
          }

          .button-82-pushable:focus:not(:focus-visible) {
            outline: none;
          }

          /* --- Car Styling --- */
          .car {
            position: absolute;
            /* Adjust bottom slightly if needed after scale change */
            bottom: 2px;
            left: 30px;
            z-index: 5;
            transform-origin: bottom center;
             /* CHANGE 2b: Make car smaller */
            transform: scale(0.7);
          }
          /* ... (rest of car styles) ... */
          .car-body {
            position: relative;
            width: 60px;
            height: 16px;
            background-color: #3498db;
            border-radius: 10px 7px 3px 4px;
            box-shadow: 0 1px 2px rgba(0,0,0,0.2);
          }
          .car-top {
            position: absolute;
            width: 35px;
            height: 12px;
            background-color: #2980b9;
            border-radius: 7px 10px 0 0;
            top: -12px;
            left: 13px;
          }
          .car-window {
            position: absolute;
            width: 12px;
            height: 6px;
            background-color: #a2d9ff;
            border-radius: 2px;
            top: -8px;
            left: 30px;
          }
          .car-tow-anchor {
            position: absolute;
            width: 4px;
            height: 4px;
            bottom: 8px;
            left: -5px;
          }


          /* --- Tow Truck Styling - REVERSED --- */
          .tow-truck {
            position: absolute;
            width: 110px; /* Width is of the unscaled element */
            height: 35px; /* Height is of the unscaled element */
             /* Adjust bottom slightly if needed after scale change */
            bottom: 2px;
            right: -155px; /* Initial position adjusted if needed */
            z-index: 10;
            transform-origin: bottom center;
             /* CHANGE 2c: Make truck smaller (and keep flip) */
            transform: scaleX(-1) scale(0.7);
          }
          /* ... (rest of truck styles) ... */
          .truck-cabin {
            position: absolute;
            width: 40px;
            height: 28px;
            background-color: #e74c3c;
            border-radius: 8px 3px 3px 3px;
            bottom: 18px;
            left: 10px;
            border-bottom: 2px solid #c0392b;
          }
          .truck-cabin:before { content: ''; position: absolute; width: 12px; height: 5px; background-color: #7f8c8d; bottom: -3px; left: -8px; border-radius: 2px; }
          .truck-cabin:after { content: ''; position: absolute; width: 8px; height: 12px; background-color: #95a5a6; bottom: 6px; left: -4px; border-radius: 1px; border: 1px solid #7f8c8d; }
          .truck-window { position: absolute; width: 16px; height: 10px; background-color: #a2d9ff; border-radius: 3px; top: 3px; right: 3px; border: 1px solid #2c3e50; }
          .truck-light { position: absolute; width: 5px; height: 5px; background-color: #f1c40f; border-radius: 50%; bottom: 8px; left: -2px; box-shadow: 0 0 3px rgba(241, 196, 15, 0.3); }
          .truck-light:after { content: ''; position: absolute; width: 5px; height: 5px; background-color: #f1c40f; border-radius: 50%; top: 7px; left: 0; box-shadow: 0 0 3px rgba(241, 196, 15, 0.3); }
          .roof-light-flasher { position: absolute; width: 6px; height: 5px; background-color: #f39c12; border-radius: 50% 50% 0 0; top: -5px; left: 16px; opacity: 0; }
          .truck-body { position: absolute; width: 70px; height: 20px; background-color: #e67e22; border-radius: 2px; bottom: 15px; left: 48px; border-bottom: 2px solid #d35400; border-top: 1px solid #f39c12; box-shadow: 0 1px 2px rgba(0,0,0,0.1); }
          .truck-bed { position: absolute; width: 28px; height: 12px; background-color: #c0392b; border-radius: 0 3px 0 0; bottom: 35px; left: 102px; border: 1px solid #7f8c8d; border-bottom: 0; transform: perspective(10px) rotateX(-5deg); }
          .tow-arm { position: absolute; width: 50px; height: 5px; background-color: #7f8c8d; bottom: 19px; left: 90px; transform-origin: 5px center; border-radius: 2px; border: 1px solid #34495e; }
          .tow-hook { position: absolute; width: 8px; height: 10px; border: 3px solid #34495e; border-left: none; border-radius: 0 5px 5px 0; right: -8px; top: -5px; background-color: #7f8c8d; }


          /* --- Wheel Styling --- */
          .car-wheel, .truck-wheel {
            position: absolute;
            background-color: #111;
            border-radius: 50%;
            /* Adjust bottom if needed after scale change */
            bottom: -8px;
            box-shadow: 0 1px 1px rgba(0,0,0,0.3);
          }
          /* Adjust wheel sizes if needed relative to new scale */
          .car-wheel { width: 14px; height: 14px; }
          .truck-wheel { width: 16px; height: 16px; bottom: 0; }
          /* ... (rest of wheel styles) ... */
           .front-wheel { left: 12px; }
          .back-wheel { right: 12px; }
          .truck-wheel.front-wheel { left: 15px; }
          .truck-wheel.back-wheel { left: 75px; right: auto; }
          .wheel-center { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 40%; height: 40%; background-color: #bdc3c7; border-radius: 50%; }


          /* --- Road Styling --- */
          .road-surface {
            position: absolute;
            bottom: 0;
            left: 0;
            /* CHANGE 2d: Adjust road height slightly */
            height: 2px;
            width: 100%;
            background-color: #34495e;
            z-index: 1;
          }
          .road-line {
            position: absolute;
            /* CHANGE 2e: Adjust road line position/height */
            bottom: 1px;
            left: 0;
            height: 1px;
            width: 100%;
            background: linear-gradient(to right, #fff 50%, transparent 50%);
            background-size: 15px 100%;
            z-index: 2;
            opacity: 0.7;
          }

          /* --- Animation Keyframes --- */
          /* Keyframes remain the same unless you want to change the sequence itself */
          @keyframes truckSequence { /* ... same keyframes ... */
             0%    { right: -135px; }
            25%   { right: 45px; }
            60%   { right: 45px; }
            100%  { right: -275px; }
           }
          @keyframes armSequence { /* ... same keyframes ... */
            0%, 25% { transform: rotate(5deg); }
            45%     { transform: rotate(-20deg); }
            100%    { transform: rotate(-20deg); }
           }
          @keyframes carSequence { /* ... same keyframes ... */
            0%, 40% { left: 30px; transform: scale(0.7) translateY(0); } /* Updated scale */
            50%     { left: 30px; transform: scale(0.7) translateY(-3px); } /* Updated scale & lift */
            60%     { left: 30px; transform: scale(0.7) translateY(-3px); } /* Updated scale & lift */
            100%    { left: 350px; transform: scale(0.7) translateY(-3px); } /* Updated scale & lift */
           }
          @keyframes wheelRotate { /* ... same keyframes ... */
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
           }
          @keyframes roadMoveRight { /* ... same keyframes ... */
             from { background-position: 0 0; }
            to { background-position: -40px 0; }
           }
          @keyframes flashLight { /* ... same keyframes ... */
            0%, 100% { opacity: 0; transform: scale(0.8); }
            50% { opacity: 1; transform: scale(1); }
           }

          /* Base state - no animations running */
          .tow-truck, .car, .tow-arm, .road-line, .truck-wheel, .car-wheel, .roof-light-flasher {
            animation: none;
          }

          /* --- Apply Animations based on .animate class --- */
          /* CHANGE 5d: Change selectors from :hover to .animate */
          .animation-scene.animate .tow-truck {
            /* CHANGE 3: Control speed here (e.g., 6s) */
            animation: truckSequence 6s ease-in-out forwards;
          }

          .animation-scene.animate .tow-arm {
            /* CHANGE 3: Control speed here (e.g., 6s) */
            animation: armSequence 6s ease-in-out forwards;
          }

          .animation-scene.animate .car {
             /* CHANGE 3: Control speed here (e.g., 6s) */
            animation: carSequence 6s ease-in-out forwards;
          }

          .animation-scene.animate .truck-wheel {
            animation: wheelRotate 0.8s linear infinite;
            /* Adjust delay if main animation duration changes */
          }

          .animation-scene.animate .car-wheel {
            animation: wheelRotate 0.8s linear infinite;
            animation-delay: 3.6s; /* Start at 60% of 6s animation */
             /* Adjust delay if main animation duration changes (e.g., 60% of new duration) */
          }

          .animation-scene.animate .road-line {
            animation: roadMoveRight 0.8s linear infinite;
            animation-delay: 3.6s; /* Start at 60% of 6s animation */
            /* Adjust delay if main animation duration changes */
          }

          .animation-scene.animate .roof-light-flasher {
            animation: flashLight 0.5s ease-in-out infinite;
            animation-delay: 0.8s; /* Adjust delay if needed */
          }

          .animation-scene.animate .truck-light,
          .animation-scene.animate .truck-light:after {
            box-shadow: 0 0 8px 3px rgba(241, 196, 15, 0.7);
            transition: box-shadow 0.3s ease 0.2s;
          }

          /* --- Responsive Adjustments --- */
          @media (max-width: 480px) {
            .tow-animation-container {
              /* Max-width might need adjustment based on new scale/layout */
              max-width: 200px; /* Example adjustment */
            }
            .animation-scene {
              /* Adjust height if needed for smaller screens */
              height: 50px;
            }
            /* You might need other responsive tweaks */
          }
        `}</style>
      </div>
    </div>
  );
};

export default EmptyStateView;